export const ERROR_MESSAGES = {
  REQUESTED_APP_NOT_AVAILABLE: "Requested app is not available",
  ITEMS_SUBMISSION_LIMIT_REACHED: "One or more items you’ve selected or added are no longer available. See below for details."

};
